"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _audioIntensityHandler = require("./audioIntensityHandler");
Object.keys(_audioIntensityHandler).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _audioIntensityHandler[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _audioIntensityHandler[key];
    }
  });
});